import React from 'react'
import { PageProps, graphql } from 'gatsby'

import { Layout } from '~/components/core/Layout'
import Seo from '~/components/core/seo'
import { HomeLayout } from '~/components/layouts/homeLayout'

interface HomeProps {
  data: Queries.HomePageQuery
  pageContext: {
    locale: string
  }
}

const Home = ({ data, pageContext }: HomeProps) => {
  const path = pageContext.locale === 'fr' ? '/' : '/en'

  console.log(process.env.GATSBY_ALGOLIA_LABO_INDEX ? process.env.GATSBY_ALGOLIA_LABO_INDEX : 'non');
  console.log(process.env.GATSBY_ALGOLIA_LABO_INDEX_ASC ? process.env.GATSBY_ALGOLIA_LABO_INDEX_ASC : 'non');
  console.log(process.env.GATSBY_ALGOLIA_LABO_INDEX_DESC ? process.env.GATSBY_ALGOLIA_LABO_INDEX_DESC : 'non');

  return (
    <Layout
      frUrl="/"
      enUrl="/en"
      initLocale={pageContext.locale}
      profile={null}
      mainTag="home"
    >
      <Seo frUrl="/" enUrl="/en" page={{ path: path }} />

      <HomeLayout
        mainDatas={data.homepage}
        events={data.events.nodes}
        news={data.news.nodes}
      />
    </Layout>
  )
}

export const pageQuery = graphql`
  query HomePage($locale: String!) {
    homepage: contentfulHomepage(
      node_locale: { eq: $locale }
      title: { ne: "dummy content" }
    ) {
      internal {
        type
      }
      heroTitleLine1
      heroTitleLine2
      heroTitleLine3
      heroText {
        heroText
      }
      heroBackground {
        altImage
        file {
          file {
            url
          }
        }
      }
      pushPage {
        node_locale
        title
        icon
        content {
          raw
          references {
            ...ContentfulFullReferenceFields
          }
        }
        proportions
        cta {
          pageLink {
            ...ContentfulPageLinkFields
          }
          customLink
          label
          assetLink {
            file {
              url
            }
          }
        }
      }
      pushContent {
        chapo {
          chapo
        }
        ctaLabel
        page {
          ...ContentfuPageFields
        }
      }
      keyFiguresTitle
      keyFiguresText: childContentfulHomepageKeyFiguresTextTextNode {
        keyFiguresText
      }
      keyFiguresFigures {
        title
        text {
          text
        }
      }
      keyFiguresLink {
        pageLink {
          ... on Node {
            ...ContentfulDatasOdreFields
            ...ContentfulEventFields
            ...ContentfulNewsFields
            ...ContentfulProjectFields
            ...ContentfulLaboFields
            ...ContentfulHomepageFields
            ...ContentfulContactFields
            ...ContentfulGovernanceFields
            ...ContentfulSimulatorFields
            ...ContentfulProfileFields
            ...ContentfulActionFields
            ...ContentfulHubFields
            ...ContentfulPageFields
            ...ContentfulMapFields
            ...ContentfulNewsroomListFields
          }
        }
        label
        customLink
        assetLink {
          file {
            url
          }
        }
      }
      imageTextSectionTags
      imageTextSectionTitle
      imageTextSectionContents {
        label
        title
        node_locale
        cta {
          pageLink {
            ... on Node {
              ...ContentfulDatasOdreFields
              ...ContentfulEventFields
              ...ContentfulNewsFields
              ...ContentfulProjectFields
              ...ContentfulLaboFields
              ...ContentfulHomepageFields
              ...ContentfulContactFields
              ...ContentfulGovernanceFields
              ...ContentfulSimulatorFields
              ...ContentfulProfileFields
              ...ContentfulActionFields
              ...ContentfulHubFields
              ...ContentfulPageFields
              ...ContentfulMapFields
              ...ContentfulNewsroomListFields
            }
          }
          label
          customLink
          assetLink {
            file {
              url
            }
          }
        }
        image {
          file {
            file {
              url
            }
          }
        }
        content {
          raw
          references {
            ...ContentfulFullReferenceFields
          }
        }
      }
    }
    events: allContentfulEvent(
      limit: 3
      sort: { startDate: ASC }
      filter: {
        distributionChannel: { elemMatch: { title: { eq: "Site internet" } } }
        fields: { isFuture: { eq: true } }
        node_locale: { eq: $locale }
        title: { ne: null }
      }
    ) {
      nodes {
        title
        node_locale
        id
        internal {
          type
        }
        mainImage {
          ...ContentfulMainImageDetailsFields
        }
        startDate
        endDate
      }
    }

    news: allContentfulNews(
      filter: {
        distributionChannel: { elemMatch: { title: { eq: "Site internet" } } }
        node_locale: { eq: $locale }
        title: { ne: null }
      }
      limit: 6
      sort: { publicationDate: DESC }
    ) {
      nodes {
        title
        internal {
          type
        }
        node_locale
        publicationDate
        createdAt
        mainImage {
          altImage
          file {
            file {
              url
              details {
                image {
                  height
                  width
                }
              }
            }
          }
        }
      }
    }
  }
`

export default Home
